import React from 'react';

const LighthouseIcon = (props) => {
  return (
    <img
      alt="Latarnia morksa"
      src="/static/images/icons/tourist_attractions/lighthouse.svg"
      {...props}
    />
  );
};

export default LighthouseIcon;
